"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.twitterPost = exports.twitterPostResultSchema = exports.twitterPostArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
// Argument schema
exports.twitterPostArgsSchema = zod_1.z.object({
    content: zod_1.z.string().describe('The content of the tweet'),
    imageUrl: zod_1.z.string().describe('Optional image URL to include').nullish(),
    emitMode: common_1.emitModeSchema
        .default('single')
        .describe('Emit mode for the tool. Default to "single".'),
});
// Result schema
exports.twitterPostResultSchema = zod_1.z.object({
    tweetId: zod_1.z.string(),
    url: zod_1.z.string(),
    content: zod_1.z.string(),
    imageUrl: zod_1.z.string().nullish(),
    postedAt: zod_1.z.string(),
});
// Tool definition
exports.twitterPost = (0, common_1.createEmitModeToolMetadata)({
    id: 'twitterPost',
    displayName: 'Twitter Post',
    displayDescription: 'Create a post on Twitter/X',
    category: 'social',
    color: common_1.BRAND_COLORS.TWITTER,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.TWITTER),
    icon: 'twitter',
    argsSchema: exports.twitterPostArgsSchema,
}, exports.twitterPostResultSchema);
